module.exports = __webpack_public_path__ + "img/registration-success.a78560a0.png";